<template>
  <v-btn class="root" v-bind:class="{ show }" rounded text :ripple="false" :color="color" :input-value="show">
    <input
      ref="search"
      type="text"
      :disabled="!show"
      :value="value"
      @input="e => $emit('input', e.target.value)"
      @keydown.enter="show = !!value; $refs.search.blur();"
      @keydown.esc.stop="show = !!value; $refs.search.blur();"
      @keydown.tab="show = !!value"
      @blur="e => { if (e.relatedTarget?.previousSibling != e.target) show = !!value; }"
      @click.capture.stop
    />
    <v-btn
      icon
      :loading="loading"
      :color="color"
      @click="() => { if (show && value) $emit('input', ''); else show = !show; }"
    >
      <v-icon v-html="value ? mdiClose : mdiMagnify" />
    </v-btn>
    <span v-if="tooltip && !show" class="btn-tooltip bottom left">{{tooltip}}</span>
  </v-btn>
</template>


<style scoped>
.v-btn.root {
  padding: 0;
  min-width: unset;
  outline: 2px solid transparent;
  transition: outline .12s;
}
.v-btn.root.show {
  outline-color: currentColor;
  background-color: #FFF;
}
input {
  padding-left: 16px;
  width: 200px;
  height: 36px;
  max-height: 36px;
  transition: padding .12s, width .12s;
  outline: none;
}
input[disabled] {
  padding-left: 0;
  width: 0;
}
</style>


<script>
import { mdiClose, mdiMagnify } from '@mdi/js';

export default {
  name: 'btn-search',

  props: [ 'value', 'tooltip', 'loading' ],

  data() {
    return {
      show: false
    };
  },

  computed: {
    color() {
      return this.value ? 'warning' : 'primary';
    }
  },

  created() {
    Object.assign(this, { mdiClose, mdiMagnify });
  },

  watch: {
    async show(v) {
      await this.$nextTick();
      v && this.$refs.search.focus();
    }
  }
}
</script>
